import axios from "axios";
import { URL_BASE } from "./0_url_base";

//const URL = 'http://localhost:3001/frotista';
//const URL = 'https://conexaodetranpr.sindilocpr.com.br/api/frotista';
const URL = URL_BASE + '/frotista';

const frotistaAPI = axios.create({
    baseURL: URL,
    headers: {
        Accept: 'application/json',
        Content: 'application/json'
    }
})

frotistaAPI.interceptors.request.use(function (config) {
    const Token = sessionStorage.getItem('token');
    if((Token) && (config.headers)){
        config.headers.Authorization = `Bearer ${Token}`
    }
    return config;
}, function (error) {
    console.log("Erro na API do Veículo");
    return Promise.reject(error);
});


frotistaAPI.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});


export {
    frotistaAPI
};